<ng-template #trocoPagamentoDesktop>
  <div class="pagamento-desktop-troco" role="group" aria-labelledby="tituloTrocoDesktop">
    <h6 id="tituloTrocoDesktop" class="pagamento-desktop-troco-titulo">
      <i class="fa fa-coins" aria-hidden="true"></i>
      Troco para pagamento em dinheiro
    </h6>
    <p class="pagamento-desktop-troco-pergunta">Vai precisar de troco?</p>
    <div class="pagamento-desktop-troco-opcoes">
      <label for="trocoSimDesktop">
        <input id="trocoSimDesktop" name="temTroco" type="radio" kendoRadioButton class="k-radio"
               [(ngModel)]="pagamento.temTroco" value="sim" [required]="true"/>
        Sim
      </label>
      <label for="trocoNaoDesktop">
        <input id="trocoNaoDesktop" name="temTroco" type="radio" kendoRadioButton class="k-radio"
               [(ngModel)]="pagamento.temTroco" value="nao" [required]="true"
               (ngModelChange)="pagamento.trocoPara = null; calculeTroco($event)"/>
        Não
      </label>
    </div>
    <div class="invalid-feedback" [class.d-block]="frm?.submitted" *ngIf="!pagamento.temTroco">Informe se vai precisar de troco.</div>
    <div class="pagamento-desktop-troco-valores" *ngIf="pagamento.temTroco === 'sim'">
      <div class="pagamento-desktop-troco-campo">
        <label for="trocoParaDesktop">Valor que vai pagar</label>
        <div class="input-group">
          <div class="input-group-prepend"><span class="input-group-text">R$</span></div>
          <input id="trocoParaDesktop" name="trocoParaDesktop" type="text" inputmode="decimal"
                 class="form-control" #txtTrocoDesktop="ngModel" [trocoMinimo]="obtenhaTotalPagar()" [trocoMaximo]="200"
                 [(ngModel)]="pagamento.trocoPara" (ngModelChange)="calculeTroco($event)" appSelecionarNoFoco
                 currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',', align: 'left' }"/>
        </div>
        <div class="invalid-feedback" [class.d-block]="txtTrocoDesktop.invalid && (txtTrocoDesktop.touched || frm?.submitted)">
          <p *ngIf="txtTrocoDesktop.errors?.trocoMinimo">Informe um valor igual ou maior que {{obtenhaTotalPagar() | currency:'BRL'}}.</p>
          <p *ngIf="txtTrocoDesktop.errors?.trocoMaximo">O valor máximo do troco é R$ 200,00.</p>
        </div>
      </div>
      <div class="pagamento-desktop-troco-resultado" *ngIf="txtTrocoDesktop.valid && pedido.troco != null" aria-live="polite" aria-atomic="true">
        <i class="fa fa-money-bill-wave" aria-hidden="true"></i>
        <span>Troco: <strong>{{pedido.troco | currency:'BRL'}}</strong></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cabecalhoPagamentoDesktop>
  <div class="pagamento-desktop-cabecalho">
    <i class="fa fa-credit-card" aria-hidden="true"></i>
    <div>
      <strong>Escolha a forma de pagamento</strong>
    </div>
  </div>
</ng-template>

<ng-template #detalhesPagamentoDesktop let-forma let-selecionada="selecionada">
  <span class="pagamento-desktop-conteudo">
    <span class="pagamento-desktop-identificacao">
      <span class="pagamento-desktop-nome">
        <app-loja-bandeira-logo *ngIf="forma.bandeira" [bandeira]="forma.bandeira"
          [descricao]="nomePagamentoDesktop(forma)"></app-loja-bandeira-logo>
        <ng-container *ngIf="!forma.bandeira">
          <i class="fa" [ngClass]="iconePagamentoDesktop(forma)" aria-hidden="true"></i>
          <strong>{{nomePagamentoDesktop(forma)}}</strong>
        </ng-container>
        <span class="pagamento-desktop-melhor" *ngIf="ofertasPagamentoDesktop[forma.id]?.melhorOferta">
          <i class="fa fa-star" aria-hidden="true"></i> Melhor oferta
        </span>
      </span>
      <span class="pagamento-desktop-descricao" *ngIf="descricaoPagamentoDesktop(forma) as descricao">{{descricao}}</span>
      <span class="pagamento-desktop-taxa" *ngIf="ofertasPagamentoDesktop[forma.id]?.taxa > 0">
        Taxa de pagamento: +{{ofertasPagamentoDesktop[forma.id].taxa | currency:'BRL'}}
      </span>
    </span>
    <ng-container *ngIf="ofertasPagamentoDesktop[forma.id] as oferta">
      <span class="pagamento-desktop-oferta" *ngIf="oferta.desconto > 0" aria-live="polite">
        <small>{{selecionada ? 'Desconto aplicado' : 'Desconto disponível'}}</small>
        <strong *ngIf="oferta.economia > 0">{{selecionada ? 'Você economiza' : 'Economize'}} {{oferta.economia | currency:'BRL'}}</strong>
        <strong *ngIf="oferta.economia <= 0">-{{oferta.desconto | currency:'BRL'}}</strong>
      </span>
    </ng-container>
    <i class="fa fa-chevron-up pagamento-desktop-expandido" *ngIf="selecionada && forma.nome === 'dinheiro'" aria-hidden="true"></i>
  </span>
</ng-template>


<kendo-tabstrip #tabFormas class="nav-bordered pagamento-desktop-tabs" id="tabs" name="tabs" (tabSelect)="alterouTipoPagamento($event)"
                *ngIf="pedido.pagamento" style="background-color: var(--cor-fundo-site, #f7f8f8); border-color: var(--cor-borda, #dee2e6);">

  <kendo-tabstrip-tab [title]=" 'Pagar pelo site'"    [selected]=" (tabSelect  === 0)" *ngIf="temPagamentoOnline()" style="color: var(--cor-texto-primaria, inherit);">
    <ng-template kendoTabContent>
      <ng-container *ngTemplateOutlet="cabecalhoPagamentoDesktop"></ng-container>

      <div class="row">
        <div class="form-group col-12 pagamento-desktop-lista"
             *ngIf="formasDePagamentoPix.length > 0 && estaHabilitado(formasDePagamentoPix[0], pedido)">
          <div class="pagamento-desktop-opcao" *ngFor="let formaDePagamento of formasDePagamentoPix"
               [class.pagamento-desktop-selecionado]="pagamentoOnlineEstaSelecionado(formaDePagamento)"
               [hidden]="!estaHabilitado(formaDePagamento, pedido)">
            <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"
                   [(ngModel)]="pedido.pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio" kendoRadioButton
                   (ngModelChange)="alterouFormaDePagamentoParaPix()"/>
            <label [for]="'formaPagamento' + formaDePagamento.id">
              <ng-container *ngTemplateOutlet="detalhesPagamentoDesktop; context: {$implicit: formaDePagamento, selecionada: pagamentoOnlineEstaSelecionado(formaDePagamento)}"></ng-container>
            </label>
          </div>

          <div class="ml-3 col" *ngIf="pedido.pagamento.formaDePagamento?.pix">

            <div class="form-group" style="max-width: 200px" *ngIf="pedirCpfNoPix()">
              <h5 style="color: var(--cor-texto-primaria, inherit);">Informe seu Cpf</h5>
              <div class="form-group">
                <input type="text" class="form-control" autocomplete="off" required  #txtCpfPix
                       id="cpf" name="cpf" [(ngModel)]="pedido.pagamento.dadosPix.cpf" #cpf="ngModel"
                       mask="000.000.000-00" cpfValido placeholder="___.___.___-__" value=""
                       style="background-color: var(--cor-fundo-elementos, white); color: var(--cor-texto-primaria, inherit); border-color: var(--cor-borda, #ced4da);">
                <div class="invalid-feedback">
                  <p *ngIf="cpf.errors?.required">Obrigatório</p>
                  <p *ngIf="cpf.errors?.cpfInvalido">CPF é invalido</p>
                </div>
              </div>
            </div>
            <div class="form-group" style="max-width: 350px" *ngIf="pedirEmailNoPix()">
              <h5 style="color: var(--cor-texto-primaria, inherit);">Informe seu Email</h5>
              <div class="input-group">
                <input id="emailPix" name="emailPix" class="form-control" #txtEmailPix email="true" type="email" emailPagamentoValido
                       #emailPix="ngModel" placeholder="Informe seu email" [required]="true"
                       [(ngModel)]="pedido.pagamento.dadosPix.email"
                       style="background-color: var(--cor-fundo-elementos, white); color: var(--cor-texto-primaria, inherit); border-color: var(--cor-borda, #ced4da);" />
                <div class="invalid-feedback">
                  <p *ngIf="emailPix.errors?.required">
                    Para pagamentos pix você deve informar seu email. Caso aconteça algum problema, usaremos esse email para te contactar.
                  </p>

                  <p *ngIf="emailPix.errors?.email || emailPix.errors?.emailPagamentoInvalido">Informe um email válido.</p>

                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="form-group col-12 cartao-online mb-0" *ngFor="let formaDePagamento of formasDePagamentoOnline">
          <div class="mb-3">
            <div class="pagamento-desktop-opcao" [hidden]="!estaHabilitado(formaDePagamento, pedido)"
                 [class.pagamento-desktop-selecionado]="pagamentoOnlineEstaSelecionado(formaDePagamento)">
              <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"
                     [(ngModel)]="pedido.pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio" kendoRadioButton
                     (ngModelChange)="escolheuFormaDePagamentoOnline(formaDePagamento)"
                     #rdFormaDePagamento="ngModel"
                     [pagseguro]="{pedido: pedido, exigeCartao: exigeCartao, dadosCartao: pagamento.dadosCartao, exigeEndereco: exigeEnderecoCobranca(formaDePagamento)}"/>
              <label [for]="'formaPagamento' + formaDePagamento.id">
                <ng-container *ngTemplateOutlet="detalhesPagamentoDesktop; context: {$implicit: formaDePagamento, selecionada: pagamentoOnlineEstaSelecionado(formaDePagamento)}"></ng-container>
              </label>
            </div>
            <button type="button" class="btn btn-blue btn-sm pagamento-desktop-acao"
                    (click)="trocarCartao()" *ngIf="pagamentoOnlineEstaSelecionado(formaDePagamento) && meioOnlineExigeCartao(formaDePagamento)">
              {{ !pagamento.dadosCartao ? 'Adicionar ' : 'Alterar '}}
            </button>

            <ng-container *ngIf="rdFormaDePagamento.errors">
              <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.endereco_obrigatorio">
                <p>Informe o endereço de cobrança da fatura do cartão de crédito</p>
              </div>
            </ng-container>
            <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.dados_cartao_obrigatorio">
              <p>Informe os dados do cartão de cŕedito</p>
            </div>
          </div>

        </div>

        <div class="col-12"  *ngIf="formaPagamentoCarteirasDigitais">
          <app-tunnapay-digitais [formaDePagamento]="formaPagamentoCarteirasDigitais" [pedido]="pedido"
           (definiuCartao)="setCartaoEscolhido($event)" (escolheuFormaPagamento)="escolheuFormaDePagamentoOnline($event)">

          </app-tunnapay-digitais>
        </div>
      </div>


      <div class="invalid-feedback ml-3" *ngIf="!pedido.pagamento.formaDePagamento">
        <p>Escolha a forma de pagamengo do seu pedido</p>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title]="'Pagar na entrega'" [selected]="tabSelect  === 1"  *ngIf="formasDePagamento.length" style="color: var(--cor-texto-primaria, inherit);">
    <ng-template kendoTabContent>
      <ng-container *ngTemplateOutlet="cabecalhoPagamentoDesktop"></ng-container>
      <div class="pagamento-desktop-lista">
        <ng-container *ngFor="let formaDePagamento of formasDePagamento">
          <div class="pagamento-desktop-opcao" [hidden]="!estaHabilitado(formaDePagamento, pedido)"
               [class.pagamento-desktop-selecionado]="pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id"
               [class.pagamento-desktop-com-troco]="formaDePagamento.nome === 'dinheiro' && pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id">
            <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"
                   [(ngModel)]="pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio" kendoRadioButton
                   [required]="true" (ngModelChange)="selecioneFormaPagamento()"/>
            <label [for]="'formaPagamento' + formaDePagamento.id">
              <ng-container *ngTemplateOutlet="detalhesPagamentoDesktop; context: {$implicit: formaDePagamento, selecionada: pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id}"></ng-container>
            </label>
            <ng-container *ngIf="formaDePagamento.nome === 'dinheiro' && pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id">
              <ng-container *ngTemplateOutlet="trocoPagamentoDesktop"></ng-container>
            </ng-container>
          </div>
        </ng-container>


      </div>

    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title]="'Pix (Chave)'"  *ngIf="formasDePagamentoManual.length " [selected]="tabSelect===2" style="color: var(--cor-texto-primaria, inherit);">
    <ng-template kendoTabContent>
      <ng-container *ngTemplateOutlet="cabecalhoPagamentoDesktop"></ng-container>

      <div class="pagamento-desktop-lista">
        <ng-container *ngFor="let formaDePagamento of formasDePagamentoManual">
          <div class="pagamento-desktop-manual"  [hidden]="!estaHabilitado(formaDePagamento, pedido)">
            <div class="pagamento-desktop-opcao"
                 [class.pagamento-desktop-selecionado]="pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id">
              <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio" kendoRadioButton
                     [(ngModel)]="pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                     (ngModelChange)="selecioneFormaPagamento()" [required]="true"/>
              <label [for]="'formaPagamento' + formaDePagamento.id">
                <ng-container *ngTemplateOutlet="detalhesPagamentoDesktop; context: {$implicit: formaDePagamento, selecionada: pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id}"></ng-container>
              </label>
            </div>

            <div class="ml-2 font-12 mt-1" *ngIf="formaDePagamento.chavePix" style="color: var(--cor-texto-primaria, inherit);">
              Chave para transferência do PIX: <b>{{formaDePagamento.chavePix}}</b>


              <div class="alert alert-info mt-2" style="background-color: var(--cor-fundo-elementos, #d1ecf1); color: var(--cor-texto-primaria, #0c5460); border-color: var(--cor-borda, #bee5eb);">
                <i class="k-icon k-i-information mr-1 text-blue" style="color: var(--cor-destaque, #007bff);"></i>
                Após realizar o pedido, faça o pagamento envie o comprovante para o lojista
              </div>

            </div>

          </div>
        </ng-container>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

</kendo-tabstrip>
